/**
 * Тексты-подсказки формы профрисков (canon service-prof-risks «Подсказки у полей — дословно из
 * Excel-анкеты»; api-contract §3f). Перенесены ДОСЛОВНО; держим в одном месте для переиспользования
 * в шагах визарда.
 */

/** Подсказки у полей — дословно из Excel-анкеты профрисков (§3f). */
export const PROFRISK_HINTS = {
  nameFull: 'Укажите полное наименование организации и в скобках сокращённое',
  legalAddress: 'Этот адрес будет фигурировать в ваших документах',
  inn: 'Введите ИНН организации',
  directorName: 'Введите ФИО руководителя организации',
  // Подсказки под полем «ФИО» контактного лица больше нет: centrika-docs!25 описывает поле как
  // выпадающий список сотрудников без подсказки (ишью #2).
  contactPhone: '+7 и 10 цифр',
  contactEmail: 'Нужны «@» и точка',
  // Подсказок под полями должности (штатные единицы / выезды на авто / оборудование) больше
  // нет: centrika-docs!26 описывает состав формы должности без них (см. PROFRISK_POSITION_*).
} as const

/**
 * Подсказка к реквизитам организации на шаге «Организация» ПОСЛЕ отправки заказа
 * (read-only просмотр снимка). Фаза 2 (§8.2, design D1, A1): пока заказ редактируем,
 * реквизиты правит клиент сам (без модерации) — эта подсказка используется только в
 * read-only-режиме уже отправленного заказа, не должна упоминать «только менеджер».
 */
export const PROFRISK_ORG_SUBMITTED_HINT =
  'Анкета отправлена — реквизиты организации зафиксированы на момент подачи заказа.'

/** Подсказка про автосохранение черновика. */
export const PROFRISK_AUTOSAVE_HINT =
  'Черновик сохраняется автоматически — заполнение можно прервать и продолжить позже.'

/** Стартовый чек-лист «Что подготовить». */
export const PROFRISK_CHECKLIST: string[] = [
  'Реквизиты организации (предзаполнены из профиля компании — можно поправить)',
  'Сведения по организации: аптечка, план эвакуации, обучение по ОТ, инструкции',
  'Список инструкций по охране труда (файлами или названиями вручную)',
  'По каждой должности: подразделение, должность, число штатных единиц, выезды на авто, оборудование',
]

/**
 * Примеры-placeholder'ы полей контактного лица (centrika-docs!25, «Шаг 1. Организация»,
 * блок «Контактное лицо» — «Поле содержит пример»).
 */
export const PROFRISK_CONTACT_PLACEHOLDERS = {
  phone: '+7 999 123-45-67',
  email: 'ot@company.ru',
} as const

// --- Шаг «Анкета» (centrika-docs!25, `component.create-profrisk-order.questionnaire`) ---
// Все тексты ниже перенесены ДОСЛОВНО из требования, включая кавычки-ёлочки и написание «е»
// в словах «введенные»/«введенный» — редактировать только вместе с требованием.

/** Блок «Что уже есть на предприятии»: заголовок + подсказка под ним. */
export const PROFRISK_CHECKLIST_TITLE = 'Что уже есть на предприятии'
export const PROFRISK_CHECKLIST_HINT =
  'Вопросы — из анкеты оценки профессиональных рисков. Отметьте «Да» или «Нет»; если чего-то нет, менеджер подскажет, как это закрыть.'
/** Ошибка под вопросом, на который не выбран ответ. */
export const PROFRISK_CHECKLIST_ERROR = 'Выберите «Да» или «Нет»'

/** Подписи кнопок выбора «Да»/«Нет» (общие для чек-листа и блока инструкций). */
export const PROFRISK_YES = 'Да'
export const PROFRISK_NO = 'Нет'

/** Блок «Разработанные инструкции по охране труда». */
export const PROFRISK_INSTRUCTIONS_TITLE = 'Разработанные инструкции по охране труда'
export const PROFRISK_INSTRUCTIONS_QUESTION =
  'В организации разработаны инструкции по охране труда?'
export const PROFRISK_INSTRUCTIONS_METHOD_QUESTION = 'Как передать список?'

/** Карточки выбора способа передачи списка: название + краткое пояснение. */
export const PROFRISK_METHOD_CARDS = {
  files: { title: 'Загрузить файлы', description: 'Передайте готовый список файлами' },
  manual: { title: 'Ввести вручную', description: 'Добавьте названия инструкций' },
} as const

/** Способ «Загрузить файлы»: область загрузки и перечень форматов под ней. */
export const PROFRISK_UPLOAD_ZONE_TEXT = 'Перетащите файлы сюда или нажмите «Выбрать файлы»'
export const PROFRISK_UPLOAD_ZONE_FORMATS = 'PDF, Word, Excel, JPG или PNG'
export const PROFRISK_UPLOAD_PICK_BUTTON = 'Выбрать файлы'
export const PROFRISK_UPLOAD_REPLACE_BUTTON = 'Заменить'
export const PROFRISK_UPLOAD_DELETE_BUTTON = 'Удалить'

/** Способ «Ввести вручную»: поле строки, placeholder первой строки и кнопка добавления. */
export const PROFRISK_MANUAL_NAME_LABEL = 'Наименование инструкции'
export const PROFRISK_MANUAL_FIRST_PLACEHOLDER =
  'Например: ИОТ-03. Инструкция по охране труда при работе с электроинструментом'
export const PROFRISK_MANUAL_ADD_BUTTON = 'Добавить инструкцию'

/** Диалоги подтверждения (заголовок, текст, кнопки — дословно). */
export const PROFRISK_CONFIRM_CANCEL = 'Отмена'
export const PROFRISK_CONFIRM_CONTINUE = 'Продолжить'
export const PROFRISK_CONFIRM_METHOD_TITLE = 'Изменить способ передачи списка?'
export const PROFRISK_CONFIRM_METHOD_TEXT =
  'Данные, введенные выбранным ранее способом, будут удалены.'
export const PROFRISK_CONFIRM_NONE_TITLE = 'Указать, что инструкции отсутствуют?'
export const PROFRISK_CONFIRM_NONE_TEXT =
  'Загруженные файлы или введенный вручную список будут удалены.'

// --- Шаг «Должности» (centrika-docs!26, `component.create-profrisk-order.positions`) ---
// Все тексты ниже перенесены ДОСЛОВНО из требования, включая кавычки-ёлочки —
// редактировать только вместе с требованием.

/** Информационный блок шапки шага (в режиме просмотра не отображается). */
export const PROFRISK_POSITIONS_INFO_TITLE = 'Профриски оцениваются по должностям, а не по людям'
export const PROFRISK_POSITIONS_INFO_BODY =
  '«Из структуры компании» — подразделение и должность подставятся сами. «Вручную» — для должностей, которых ещё нет в кабинете. Количество штатных единиц укажите вручную.'

/** Кнопки добавления должности: основное действие и дополнительное (в одной строке). */
export const PROFRISK_POSITIONS_FROM_STRUCTURE = 'Из структуры компании'
export const PROFRISK_POSITIONS_ADD_MANUAL = 'Добавить вручную'

/** Пустое состояние списка должностей. */
export const PROFRISK_POSITIONS_EMPTY =
  'Пока не добавлено ни одной должности — выберите из структуры компании или добавьте вручную.'

/** Пояснение под списком должностей либо пустым состоянием. */
export const PROFRISK_POSITIONS_LIST_NOTE =
  '«Количество карт по итогу работ» заполняет лаборатория — вам вносить его не нужно. Графу «оборудование, материалы, сырьё» можно оставить пустой, менеджер уточнит при проверке.'

/** Заголовок карточки должности без заполненного наименования. */
export const PROFRISK_POSITION_UNNAMED = 'Должность не указана'

/**
 * Метки источника должности в заголовке формы. Пустой источник (`''`) — должность создана
 * до centrika-docs!26, метка НЕ показывается (см. design D1 профриск-change'а).
 */
export const PROFRISK_POSITION_SOURCE_LABELS = {
  structure: 'из структуры',
  manual: 'вручную',
  import: 'из файла',
} as const

/** Кнопка удаления должности из заказа (без подтверждения). */
export const PROFRISK_POSITION_REMOVE = 'Убрать'

/** Подписи полей формы должности. */
export const PROFRISK_POSITION_FIELDS = {
  department: 'Подразделение',
  position: 'Должность',
  headcount: 'Штатных единиц',
  vehicleUse: 'Выезды на служебном авто',
  equipment: 'Оборудование, материалы, сырьё, инструменты',
} as const

/** Placeholder'ы полей формы должности. */
export const PROFRISK_POSITION_PLACEHOLDERS = {
  department: 'Выберите подразделение',
  equipment:
    'Например: сварочный аппарат, ручной инструмент, металл, лакокрасочные материалы',
} as const

/** Диалоговое окно «Должности из структуры компании». */
export const PROFRISK_STRUCTURE_DIALOG_TITLE = 'Должности из структуры компании'
export const PROFRISK_STRUCTURE_DIALOG_HINT =
  'Отметьте должности — подразделение и должность подставятся сами. Список собран из пульта «Охрана труда»; вакантные места включены.'
/** Кнопки массового выбора над списком подразделений (каждая ЗАМЕНЯЕТ текущий набор). */
export const PROFRISK_STRUCTURE_SELECT_ALL = 'Все'
export const PROFRISK_STRUCTURE_SELECT_NOT_ASSESSED = 'Выбрать должности без профрисков'
export const PROFRISK_STRUCTURE_SELECT_NONE = 'Снять выбор'
/** Пометка должности, уже добавленной к текущему заказу. */
export const PROFRISK_STRUCTURE_ALREADY = 'уже в заказе'
export const PROFRISK_STRUCTURE_CANCEL = 'Отмена'
export const PROFRISK_STRUCTURE_SUBMIT = 'Добавить выбранные'

// --- Загрузка «Анкеты и формы (РИСКИ)» (order-import-legacy-forms) ---

/** Заголовок диалога загрузки. */
export const PROFRISK_IMPORT_TITLE = 'Загрузка анкеты профрисков из файла'

/** Что за файл и что из него попадёт в заказ. */
export const PROFRISK_IMPORT_DESCRIPTION =
  'Выберите «Анкету и форму (РИСКИ)» в Excel. Каждая строка листа «Формы» станет должностью ' +
  'заказа с подразделением, количеством штатных единиц, выездами на авто и оборудованием. С ' +
  'листа «Анкета» переносятся контактное лицо, ответы «Да/Нет» и список инструкций по охране ' +
  'труда — только то, что в заказе ещё не заполнено.'
